import { render, staticRenderFns } from "./tax-invoice.vue?vue&type=template&id=1026e20f&scoped=true"
import script from "./tax-invoice.vue?vue&type=script&lang=ts"
export * from "./tax-invoice.vue?vue&type=script&lang=ts"
import style0 from "./tax-invoice.vue?vue&type=style&index=0&id=1026e20f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1026e20f",
  null
  
)

export default component.exports